import React from "react";
import { Card } from "@/components/ui/card";
import Waveform from "@/components/shared/Waveform";

export const LandingAudioProcessingCard = ({ t, language, demoQuote, demoMoments, className = "" }) => {
  return (
    <Card className={`bg-card border-border p-6 card-hover ${className}`.trim()} data-testid="landing-audio-processing-card">
      <div className="mb-4 flex items-center justify-between">
        <span className="text-sm font-mono text-muted-foreground" data-testid="landing-audio-processing-title">
          {t("audioProcessing")}
        </span>
        <span className="flex items-center gap-2 text-xs font-mono text-green-500" data-testid="landing-audio-processing-status">
          <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
          {t("analyzing")}
        </span>
      </div>

      <Waveform isAnimating={true} barCount={50} />

      <div className="mt-6 rounded border border-primary/20 bg-primary/5 p-4" data-testid="landing-audio-processing-highlight-card">
        <div className="mb-3 flex items-center gap-2">
          <span className="timestamp-pill" data-testid="landing-audio-processing-highlight-timestamp">02:14</span>
          <span className="text-sm font-medium text-primary" data-testid="landing-audio-processing-highlight-label">
            {t("keyInsightDetected")}
          </span>
        </div>
        <p className="font-mono text-sm leading-relaxed text-muted-foreground" data-testid="landing-audio-processing-highlight-copy">
          "...{language === "es" ? "los" : "the"}{" "}
          <span className="font-semibold text-primary">{demoQuote.highlight}</span>{" "}
          {demoQuote.text}
        </p>
      </div>

      <div className="mt-4 space-y-2" data-testid="landing-audio-processing-moments-list">
        {demoMoments.map((moment, idx) => (
          <div
            key={`${moment.time}-${idx}`}
            className="flex items-start gap-3 rounded p-2 transition-colors hover:bg-muted/30"
            data-testid={`landing-audio-processing-moment-${idx + 1}`}
          >
            <span className="timestamp-pill shrink-0">{moment.time}</span>
            <span className="text-xs leading-relaxed text-muted-foreground">{moment.text}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};
